var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row basemap-gallery" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialSelect",
                {
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    disabled: _vm.readonlyFormItem,
                    id: "input-group",
                    name: "group",
                    label: "name",
                    filterable: false,
                    options: _vm.groups,
                    reduce: (option) => option.id,
                  },
                  on: {
                    input: function ($event) {
                      _vm.form.id = null
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "option",
                      fn: function ({ option, label }) {
                        return [
                          _c("div", { staticClass: "d-flex flex-row" }, [
                            option.image
                              ? _c("img", {
                                  staticClass: "img-icon w-24 mr-2",
                                  attrs: { src: option.image },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", {}, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(option[label]) +
                                  "\n                                "
                              ),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.form.group_id,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "group_id",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.group_id",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t(`${_vm.translatedId}.model.group`)) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("hr", { staticClass: "mt-0" }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            { staticClass: "row" },
            _vm._l(_vm.groupedItems, function (item, index) {
              return _c(
                "div",
                {
                  key: `grouped-item-${item.group_id}-${index}`,
                  staticClass: "col-6 col-md-3 mb-3",
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "card-group-toggle",
                      attrs: {
                        title: _vm.$t(`${_vm.translatedId}.select_item`),
                        "data-toggle": "tooltip-city",
                      },
                      on: {
                        dblclick: function ($event) {
                          $event.preventDefault()
                          return _vm.onSelectedItem(
                            item.id,
                            item.group_id,
                            item,
                            $event
                          )
                        },
                      },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.id,
                            expression: "form.id",
                          },
                        ],
                        attrs: {
                          type: "radio",
                          name: "rouped-item-id",
                          id: `rouped-item-${item.id}`,
                        },
                        domProps: {
                          value: item.id,
                          checked: _vm._q(_vm.form.id, item.id),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(_vm.form, "id", item.id)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "card square square-2",
                          class: [{ active: _vm.form.id == item.id }],
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "card-body p-2 d-flex flex-column" },
                            [
                              _c("img", {
                                staticClass: "img-item",
                                attrs: { src: item.image ?? _vm.noImage },
                              }),
                              _vm._v(" "),
                              _c("h6", { staticClass: "card-title" }, [
                                _vm._v(_vm._s(item.name)),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }